<template>
  <el-dialog
    :visible="visible"
    class="responsive student-result-history-modal"
    width="900px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <span slot="title" class="modal-title">
      {{ modalTitle }}
    </span>

    <div v-loading="loading" class="history-content">
      <div v-if="!loading && (!data || data.length === 0)" class="empty-state">
        Chưa có lịch sử
      </div>

      <div v-else class="history-table-wrapper">
        <table class="table table-bordered table-vertical-center history-table mb-0">
          <thead class="history-thead bg-light">
            <tr>
              <th
                v-for="col in columns"
                :key="col.key"
                scope="col"
                class="text-center align-middle font-weight-bold"
              >
                {{ col.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in data" :key="index">
              <td v-for="col in columns" :key="col.key" class="text-center align-middle">
                <template v-if="col.key === 'updated_at'">
                  {{ formatDateTime(row[col.key]) }}
                </template>
                <template v-else-if="col.key === 'updated_by'">
                  {{ formatUpdatedBy(row) }}
                </template>
                <template v-else>
                  {{ row[col.key] ?? '-' }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <footer class="d-flex justify-content-end pt-4">
      <button type="button" class="btn btn-secondary font-weight-bold" @click="handleClose">Đóng</button>
    </footer>
  </el-dialog>
</template>

<script>
import moment from 'moment';

export default {
  name: 'StudentExamResultHistoryModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: null,
    },
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalTitle() {
      const name = this.record?.student_name || '';
      const phone = this.record?.phone || '';
      return `Lịch sử điểm thi đầu khóa - ${name} - ${phone}`;
    },
    columns() {
      return [
        { key: 'listening', label: 'Listening' },
        { key: 'reading', label: 'Reading' },
        { key: 'writing', label: 'Writing' },
        { key: 'speaking', label: 'Speaking' },
        { key: 'overall', label: 'Overall' },
        { key: 'updated_at', label: 'Thời gian cập nhật' },
        { key: 'updated_by', label: 'Người cập nhật' },
      ];
    },
  },
  methods: {
    formatDateTime(value) {
      if (!value) return '-';
      return moment(value).format('HH:mm:ss DD/MM/YYYY');
    },
    formatUpdatedBy(row) {
      if (!row.updated_by_name && !row.updated_by_code) {
        return '-';
      }
      return `${row.updated_by_name || ''} - ${row.updated_by_code ?? ''}`.trim();
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.student-result-history-modal >>> .el-dialog__header {
  padding-bottom: 0.5rem;
}

.modal-title {
  font-weight: 600;
  font-size: 1rem;
}

.history-content {
  min-height: 120px;
}

.empty-state {
  text-align: center;
  padding: 3rem 1rem;
  color: #6c757d;
  font-size: 0.9375rem;
}

.history-table-wrapper {
  border: 1px solid #ebedf3;
  border-radius: 0.25rem;
  max-height: 400px;
  overflow-y: auto;
}

.history-thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.history-table th,
.history-table td {
  vertical-align: middle;
  padding: 0.6rem 0.75rem;
}
</style>
